import React from "react";
import { colors, font } from "../utils/theme.js";
import { isOpen, isOverdue } from "../crm/crmLogic.js";

const fmt = (d) => new Date(`${d}T12:00:00Z`).toLocaleDateString("en-US", { timeZone: "UTC", weekday: "short", month: "short", day: "numeric" });

// "CRM follow-ups" on My Tasks (CRM spec 2026-11-03): this person's open CRM tracks with a dated
// next step, soonest first. A row opens the track on its client's CRM tab via onOpen(hash, page)
// (the app's navigation — App only reads the hash when a page mounts). Not tasks — they
// never touch the task container or client task counts.
export default function CrmFollowUps({ tracks, contacts, clientName, today, onOpen }) {
  const nameOf = new Map((contacts || []).map((c) => [c.id, c.name]));
  const rows = (tracks || [])
    .filter((t) => isOpen(t) && t.nextStepDate && nameOf.has(t.contactId))
    .sort((a, b) => (a.nextStepDate === b.nextStepDate ? 0 : a.nextStepDate < b.nextStepDate ? -1 : 1));
  if (!rows.length) return null;
  return (
    <div style={{ marginBottom: 22 }}>
      <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase", color: colors.textDim, marginBottom: 8 }}>CRM follow-ups ({rows.length})</div>
      {rows.map((t) => {
        const over = isOverdue(t, today);
        return (
          <button key={t.id} type="button" onClick={() => onOpen?.(`client=${encodeURIComponent(t.clientId)}&crm=${encodeURIComponent(t.id)}`, "clients")}
            style={{ display: "flex", width: "100%", alignItems: "center", gap: 12, textAlign: "left", background: colors.surface, border: `1px solid ${over ? "rgba(239,68,68,0.4)" : colors.border}`, borderRadius: 8, padding: "9px 12px", marginBottom: 6, cursor: "pointer", fontFamily: font, color: colors.text }}>
            <span style={{ flex: 1, minWidth: 0 }}>
              <span style={{ fontSize: 13, fontWeight: 600 }}>{t.nextStep || "Follow up"}</span>
              <span style={{ fontSize: 12, color: colors.textMuted }}> · {nameOf.get(t.contactId)} · {clientName(t.clientId) || "Client"}</span>
            </span>
            <span style={{ fontSize: 12, whiteSpace: "nowrap", color: over ? colors.danger : colors.textMuted, fontWeight: over ? 700 : 400 }}>{fmt(t.nextStepDate)}{over ? " · overdue" : ""}</span>
          </button>
        );
      })}
    </div>
  );
}
